// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DocumentsV2FillablePdfPdfFileData } from './documentsV2FillablePdfPdfFileData.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentsV2FillablePdfGenerateFillablePdfRequestModel {
    'fileUrl': string;
    'outputFileName': string;
    'fileData': Array<DocumentsV2FillablePdfPdfFileData>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentsV2FillablePdfGenerateFillablePdfRequestModel>> = [
        {
            "name":     "fileUrl",
            "baseName": "fileUrl",
            "type":     "string"
        },
        {
            "name":     "outputFileName",
            "baseName": "outputFileName",
            "type":     "string"
        },
        {
            "name":     "fileData",
            "baseName": "fileData",
            "type":     "Array<DocumentsV2FillablePdfPdfFileData>"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentsV2FillablePdfGenerateFillablePdfRequestModel.attributeTypeMap;
    }
}
